import {
	Id,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { ContactPhoneSaveRequest, IContactPhoneIndexResource, IContactPhoneUpdateResource } from "../types";

const baseKey = "contact-phones";
const markAsPrimaryKey = (id: Id) => [baseKey, `${id}`, "change-primary"];

export const contactPhoneService = {
	...withIndexEndpoint<IContactPhoneIndexResource>([baseKey]),
	...withShowEndpoint<IContactPhoneUpdateResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withStoreEndpoint<ContactPhoneSaveRequest>([baseKey]),
	...withUpdateEndpoint<ContactPhoneSaveRequest>([baseKey]),
	markAsPrimary: (id: Id) => axios.put(keyToUrl(markAsPrimaryKey(id))),
	markAsPrimaryKey,
};
